import { getAdministratedPortfolio } from 'modules/society/api/getAdministratedPortfolio';
import { useCallback, useEffect, useState } from 'react';
import { store } from 'redux/store';

type UseGetPortfolioData = {
  userId: string;
  societyId?: string;
};

const countNodes = (node: any) => {
  if (!node) return 0;

  return (
    1 +
    (node.children?.reduce(
      (sum: any, child: any) => sum + countNodes(child),
      0
    ) || 0)
  );
};

export const useGetAdministratedPortfolio = ({
  userId,
  societyId,
}: UseGetPortfolioData) => {
  const [portfolio, setPortfolio] = useState<any>([]);
  const [nodesCount, setNodesCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchPortfolio = useCallback(
    async (controller: AbortController) => {
      try {
        setIsLoading(true);

        const resultData = await store.dispatch(
          getAdministratedPortfolio({
            userId,
            societyId,
            signal: controller.signal,
          })
        );

        const nodesCountValue = countNodes(resultData);

        if (!controller.signal.aborted) {
          setPortfolio(resultData);
          setNodesCount(nodesCountValue);
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
          setIsError(true);
        }
      }
    },
    [userId, societyId]
  );

  useEffect(() => {
    const controller = new AbortController();

    fetchPortfolio(controller);

    return () => controller.abort();
  }, [fetchPortfolio]);

  return { data: { portfolio, nodesCount }, isLoading, isError };
};
